module.exports = __webpack_public_path__ + "static/media/Volkswagen_logo_2019.d7ded5a1.svg";